var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVector71(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 92,
    height: 329,
    viewBox: "0 0 92 329",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-216.023 328.206C-197.108 304.818 -192.989 301.111 -173.58 286.295C-168.826 282.665 -159.582 276.953 -148.164 271.498C-144.747 269.863 -141.359 268.381 -138.018 267.022C-114.111 257.328 -87.3281 255.959 -60.8772 258.212C6.61188 263.962 67.5238 227.43 85.2811 172.119C103.076 116.703 73.8163 55.1862 28.156 25.1643C22.2148 21.2583 -5.82107 4.0283 -36.5808 1.48133C-133.7 -6.58724 -172.508 87.489 -201.892 230.632C-202.461 233.417 -204.634 246.674 -205.023 249.488L-216.023 328.215L-216.023 328.206Z",
    stroke: "#A8AEBE",
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector71);
export default __webpack_public_path__ + "static/media/vector7-1.923fc474f4b424634abf9603177d2102.svg";
export { ForwardRef as ReactComponent };